import { render, staticRenderFns } from "./ReportePrincipal.vue?vue&type=template&id=11897668"
import script from "./ReportePrincipal.vue?vue&type=script&lang=js"
export * from "./ReportePrincipal.vue?vue&type=script&lang=js"
import style0 from "./ReportePrincipal.vue?vue&type=style&index=0&id=11897668&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports